export default "__VITE_ASSET__915d2248__"